import React from "react";
import { useAuth } from "../../context/AuthContext";

const isInvalidUser = Component => ({ ...props }) => {
  const [{ user }] = useAuth();
  const valid = (user && user.valid);

  return (valid ? null : <Component {...props} />);
};

export { isInvalidUser };
